<template>
    <div>
        <div class="topheader">
            <div class="qyname">{{ nsrmc }}</div>
            <div class="qycode">{{ nsrsbh }}</div>
            <div class="qylable">
                <div>高新技术企业</div>
                <div>科技型中小企业</div>
                <div>专精特新中小企业</div>
            </div>
            <van-tabs v-model="active" color="#3A71FF">
                <van-tab title="基本信息"></van-tab>
                <van-tab title="纳税信息"></van-tab>
                <van-tab title="发票信息"></van-tab>
                <van-tab title="供应商信息"></van-tab>
                <van-tab title="个人征信"></van-tab>
                <van-tab title="企业征信"></van-tab>
            </van-tabs>
        </div>


        <div class="detailView">
            <div v-if="active === 0">
                <BaseInfo :detail="detail" :createTime="createTime" />
            </div>
            <div v-if="active === 1">
                <TaxpaymentInfo :detail="detail" />
            </div>
            <div v-if="active === 2">
                <InvoiceInfo :detail="detail" />
            </div>
            <div v-if="active === 3">
                <SupplierInfo :detail="detail" />
            </div>
            <div v-if="active === 4">
                <van-empty v-if="resultData.personageStatus != 2" :description="gerenMessage" />
                <PersonInfo v-else :detail="gerenWord" />
            </div>
            <div v-if="active === 5">
                <van-empty v-if="resultData.firmStatus != 2" :description="qiyeMessage" />
                <EnterpriseInfo v-else :detail="qiyeWord" />
            </div>
        </div>
    </div>
</template>

<script>
require("@/style/common.css")
import request from "@/utils/request";
import BaseInfo from "./components/BaseInfo.vue"
import TaxpaymentInfo from "./components/TaxpaymentInfo.vue"
import InvoiceInfo from "./components/InvoiceInfo.vue"
import SupplierInfo from "./components/SupplierInfo.vue"
import PersonInfo from "./components/PersonInfo.vue"
import EnterpriseInfo from "./components/EnterpriseInfo.vue"

export default {
    components: {
        BaseInfo,
        TaxpaymentInfo,
        InvoiceInfo,
        SupplierInfo,
        PersonInfo,
        EnterpriseInfo,
    },
    props: {
        id: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            active: 0,
            detail: null,
            resultData: {
                id: "",
            },
            gerenMessage: "",
            qiyeMessage: "",
            nsrmc: "",
            nsrsbh: "",
            createTime: "",
            qiyeWord: null,
            gerenWord: null,
        }
    },
    created() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            let self = this;
            request.get("/Data/ReportTask/GetRecordById", {
                params: { id: this.id }
            }).then((res) => {
                // console.log(res);
                let dataResult = res.data.data;
                self.resultData = res.data.data;
                self.getGrQyWord(dataResult.id)

                try {
                    if (dataResult && dataResult.status === 1) {
                        if (dataResult.personageStatus === 0) {
                            self.gerenMessage = "未上传个人征信信息"
                        }
                        if (dataResult.personageStatus === 1) {
                            self.gerenMessage = "个人征信信息识别中";
                        }

                        if (dataResult.firmStatus === 0) {
                            self.qiyeMessage = "未上传企业征信信息";
                        }
                        if (dataResult.firmStatus === 1) {
                            self.qiyeMessage = "企业征信信息识别中";
                        }

                        if (dataResult.firmStatus === 2 && dataResult.personageStatus === 2) {
                            self.isUploadZx = true;
                        }

                        if (dataResult.contentJson) {
                            let resultData = JSON.parse(dataResult.contentJson);

                            self.nsrmc = resultData.baseinfoVo.nsrmc;
                            self.nsrsbh = resultData.baseinfoVo.nsrsbh;
                            self.createTime = dataResult.createTime;

                            console.log(resultData);
                            self.detail = resultData;
                        }
                    } else {
                        let message = "";
                        // // 跳转到
                        if (dataResult.status === 0) {
                            message = "报告正在生成中，请耐心等待！"
                        } else if (dataResult.status === 2) {
                            message = "报告已作废，暂无法查看！"
                        } else {
                            message = "获取报告失败！"
                        }

                        self.$router.push("/callbackResult?t=" + message);
                    }
                } catch (message) {
                    console.log("获取企业报告失败：" + message);
                }
            })
        },
        getGrQyWord(id) {
            // 个人/企业征信
            let self = this;
            request.get("/Data/ReportTask/GetPTPResult", { params: { id: id } }).then((res) => {
                // console.log(res);
                try {
                    if (res.data) {
                        if (res.data.data.firmResult) {
                            let data = JSON.parse(res.data.data.firmResult);
                            console.log(data);
                            self.qiyeWord = data;
                        } else {
                            self.qiyeWord = false;
                        }
                        if (res.data.data.personageResult) {
                            let data = JSON.parse(res.data.data.personageResult);
                            // console.log(data);
                            self.gerenWord = data;
                        } else {
                            self.gerenWord = false;
                        }
                    } else {
                        self.qiyeWord = false;
                        self.gerenWord = false;
                    }
                } catch (err) {
                    console.error(err)
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.topheader {
    overflow: hidden;
    background: linear-gradient(180deg, #3a81ff 0%, #F0F4FF 96.34%);
}

.qyname {
    font-size: 1rem;
    color: #fff;
    padding-left: .8rem;
    margin-top: .8rem;
}

.qycode {
    font-size: .8rem;
    color: #fff;
    padding-left: .8rem;
    margin-top: .8rem;
}

.qylable div {
    font-size: .6rem;
    color: #fff;
    display: inline-block;
    border-radius: .5rem;
    padding: 0 .5rem;
    line-height: 1rem;
    border: solid 1px #fff;
    margin: .5rem 0 .8rem .8rem;
    background: #3a71ff80;
}

.detailView {
    border-top: solid .5rem #F0F4FF;
    padding-bottom: 5rem;
}
</style>